import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
     selector: 'app-login-layout',
     standalone: true,
     imports: [],
     templateUrl: './login-layout.component.html',
     styleUrl: './login-layout.component.scss'
})

export class LoginLayoutComponent implements OnInit, OnDestroy {
     private sub:any = null;

     constructor(
          private router: Router,
     ) { }

     ngOnInit() {
          this.sub = window.addEventListener('storage', (event) => {
               if(event?.newValue && event?.newValue != '') {
                    this.autoSignIn();
               }
          });
     }

     ngOnDestroy() {
          if (this.sub != null) {
               this.sub.unsubscribe();
          }
     }

     autoSignIn() {
          this.router.navigate(['/dashboard']);
     }

     
}